import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { FoldingArrowDown } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import { hasSelectedChild } from "../../utils/categoryTree";
export const LNBItem = (param)=>{
    let { item , depth , selectedCategoryId , expandedIds , onSelect , onToggle , pageType ="edition"  } = param;
    var _item_items;
    const hasChildren = !!((_item_items = item.items) === null || _item_items === void 0 ? void 0 : _item_items.length);
    const isExpanded = expandedIds.has(item.categoryId);
    const isSelected = selectedCategoryId === item.categoryId;
    const isParentOfSelected = hasChildren && hasSelectedChild(item.items, selectedCategoryId);
    const isHighlighted = isSelected || isParentOfSelected;
    // 타이포그래피 variant: 선택된 항목 또는 상위 depth는 bold
    const variant = depth === 1 ? isHighlighted ? "subtitle1" : "body1" : isHighlighted ? "subtitle2" : "body2";
    // 텍스트 색상: 선택된 항목 또는 선택된 항목의 상위 depth는 text-strong
    const textColor = isHighlighted ? "text-strong" : depth === 1 ? "text-primary" : "text-secondary";
    // 배경: 선택된 항목만 bg-gray-50
    const bgClass = isSelected ? "bg-gray-50 hover:bg-gray-900/[0.06]" : "hover:bg-gray-50";
    const handleClick = ()=>{
        // MX-363/MX-369: LNB 카테고리 클릭 이벤트 트래킹
        if (pageType === "system") {
            // MX-369: System Category용 이벤트
            mixpanelEvent("Category LNB Clicked", {
                "Item Name": item.title,
                "Item Url": item.link || "",
                "Item Depth": depth,
                Position: "System Category"
            });
        } else {
            // MX-363: Edition Category용 이벤트
            mixpanelEvent("Category LNB Clicked", {
                "Button URL": item.link || "",
                "Button Name": item.title,
                ID: item.categoryId,
                Depth: depth,
                Position: "Edition Category LNB"
            });
        }
        // 하위 항목이 있으면 토글
        if (hasChildren) {
            onToggle(item.categoryId);
        }
        // 항상 선택 이벤트 발생 (link가 있으면 link 전달)
        onSelect(item.categoryId, item.link);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(depth === 1 ? "ml-0" : "ml-3"),
        children: [
            /*#__PURE__*/ _jsxs("button", {
                type: "button",
                onClick: handleClick,
                className: cn("flex w-full items-center justify-between gap-1.5", "min-h-10 rounded-sm px-2 py-2 text-left", "transition-colors duration-150 active:bg-gray-900/12", bgClass),
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: variant,
                        className: cn("flex-1 break-keep", textColor),
                        children: item.title
                    }),
                    hasChildren && /*#__PURE__*/ _jsx(Icon, {
                        icon: FoldingArrowDown,
                        className: cn("size-3 shrink-0 transition-transform duration-200", isHighlighted ? "text-gray-900" : "text-gray-400", isExpanded ? "rotate-0" : "rotate-180")
                    })
                ]
            }),
            hasChildren && isExpanded && /*#__PURE__*/ _jsx("div", {
                className: "flex flex-col",
                children: item.items.map((child)=>/*#__PURE__*/ _jsx(LNBItem, {
                        item: child,
                        depth: depth + 1,
                        selectedCategoryId: selectedCategoryId,
                        expandedIds: expandedIds,
                        onSelect: onSelect,
                        onToggle: onToggle,
                        pageType: pageType
                    }, child.categoryId))
            })
        ]
    });
};
